import React from 'react';

const ErrorCode = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="167"
      height="68"
      viewBox="0 0 167 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M32.5506 66.5337V52.9703H0V44.5391L31.3686 1.4663H42.3703V43.9892H50.2806V52.9703H42.3703V66.5337H32.5506ZM11.1836 43.9892H32.5506V15.2129L11.1836 43.9892Z"
        fill="white"
      />
      <path
        d="M84.3684 68C79.0342 68 74.3971 66.6253 70.4571 63.876C66.5171 61.1267 63.4863 57.2165 61.3648 52.1455C59.2432 47.0746 58.1824 41.0566 58.1824 34.0916C58.1824 27.1267 59.2432 21.1087 61.3648 16.0377C63.5469 10.9057 66.5777 6.96496 70.4571 4.21563C74.3971 1.40521 79.0342 0 84.3684 0C89.7632 0 94.4003 1.40521 98.2797 4.21563C102.22 6.96496 105.25 10.8751 107.372 15.9461C109.554 21.0171 110.645 27.0656 110.645 34.0916C110.645 41.0566 109.584 47.0746 107.463 52.1455C105.341 57.2165 102.311 61.1267 98.3706 63.876C94.4306 66.6253 89.7632 68 84.3684 68ZM84.3684 58.9272C89.5207 58.9272 93.491 56.7889 96.2794 52.5121C99.0677 48.2354 100.462 42.0952 100.462 34.0916C100.462 28.7152 99.8254 24.1635 98.5524 20.4367C97.3401 16.7098 95.5217 13.8994 93.097 12.0054C90.733 10.0503 87.8235 9.07277 84.3684 9.07277C80.9739 9.07277 78.0644 10.0503 75.6397 12.0054C73.2757 13.8994 71.4573 16.7098 70.1843 20.4367C68.972 24.1635 68.3659 28.7152 68.3659 34.0916C68.3659 42.0952 69.76 48.2354 72.5483 52.5121C75.3367 56.7889 79.2767 58.9272 84.3684 58.9272Z"
        fill="white"
      />
      <path
        d="M149.27 66.5337V52.9703H116.719V44.5391L148.088 1.4663H159.09V43.9892H167V52.9703H159.09V66.5337H149.27ZM127.903 43.9892H149.27V15.2129L127.903 43.9892Z"
        fill="white"
      />
    </svg>
  );
};

export default ErrorCode;
